module.exports = __webpack_public_path__ + "img/instagram_1@4x.395073a5.png";